// sagas.ts
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchUserAssetsFailure,
    fetchUserAssetsSuccess,
    fetchUserPnLExpectedFailure,
    fetchUserPnLExpectedSuccess,
    fetchUserPnLFailure,
    fetchUserPnLSuccess,
} from './actions';
import api from '../../../api-new/http';
import { appUrls } from '../../../api-new/urls';
import { FETCH_USER_ASSETS_REQUEST, FETCH_USER_PNL_EXPECTED_REQUEST, FETCH_USER_PNL_REQUEST } from './constants';
import { sendError } from '../../public/errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';
export function* usetAssetsSaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/assets`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchUserAssetsSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchUserAssetsFailure(error));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* userPnLSaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/user/profit-loss`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchUserPnLSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchUserPnLFailure(error));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* userPnLExpectedSaga() {
    try {
        const data = yield call(() =>
            api.get(`${appUrls.tradeURL}/user/profit-loss-expected`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('csrfToken')}`,
                },
            }),
        );
        if (data) {
            yield put(fetchUserPnLExpectedSuccess(data.data.data));
        }
    } catch (error) {
        yield put(fetchUserPnLExpectedFailure(error));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}

export function* rootUserAssetsSaga(): Generator {
    yield takeLatest(FETCH_USER_ASSETS_REQUEST, usetAssetsSaga);
    yield takeLatest(FETCH_USER_PNL_REQUEST, userPnLSaga);
    yield takeLatest(FETCH_USER_PNL_EXPECTED_REQUEST, userPnLExpectedSaga);
}
